import React, { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { getWebOrdersByCustomer } from '../apis/backendRequests'
import { makeRequest } from '../apis/makeRequest'
import { cartActions } from '../actions/cartActions'
import { styled } from '@mui/material/styles'
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import { Table, TableContainer, TableHead, TableRow, Paper, TableBody, IconButton, Button } from '@mui/material'
import InfoIcon from '@mui/icons-material/Info';
import PopUpOrder from './PopUpOrder'
import { GetDetailOrder } from '../helpers/GetDetailsOrder'
import { notificationActions, orderActions } from '../actions'
import { useNavigate } from 'react-router-dom'

const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: theme.palette.common.black,
        color: theme.palette.common.white,
        fontSize: 19,
    },
    [`&.${tableCellClasses.body}`]: {
        backgroundColor: '#f5f5f5',
        fontSize: 17,
    },
}));

export default function Order() {

    const dispatch = useDispatch()
    const navigate = useNavigate()
    const { dynamicsId } = useSelector(state => state.account)
    const [webOrder, setWebOrder] = useState([])
    const [rowPopUp, setRowPopUp] = useState({ item: {}, open: false })
    const { items } = useSelector((state) => state.cart)
    // const { items } = useSelector((state) => state.order);


    useEffect(() => {
        if (webOrder.length !== 0)
            return

        const status = [1, 2, 3]
        makeRequest(
            () => getWebOrdersByCustomer(dynamicsId, status),
            (res) => {
                if (res.data.length !== 0) { setWebOrder(res.data) }
                else { return }
            }, null, { checkEmptyResults: false }
        )
    }, [webOrder, dynamicsId])

    const handleViewOrder = async (event, item) => {
        dispatch(orderActions.clear())
        dispatch(orderActions.setOrderId(item.webOrderId))

        if (item.integrationId !== "XXX" && item.integrationId)
            dispatch(orderActions.setIntegrationId(item.integrationId))

        const result = await GetDetailOrder(dynamicsId, item.webOrderId, dispatch, orderActions);
        
        if (result?.success === false) {
            dispatch(notificationActions.showError({ message: "Error al obtener algunos productos del pedido" }));
        }
        
        setRowPopUp({ item, open: true })
    }


    const handleEditOrder = async (event, item) => {
        dispatch(cartActions.clear())
        dispatch(cartActions.setOrderId(item.webOrderId))

        if (item.integrationId !== "XXX" && item.integrationId)
            dispatch(cartActions.setIntegrationId(item.integrationId))

        const result = await GetDetailOrder(dynamicsId, item.webOrderId, dispatch, cartActions, true);
        
        if (result?.success === false) {
            dispatch(notificationActions.showError({ message: "Error al obtener algunos productos del pedido" }));
        }
        
        navigate("/cart", { state: items })
    }

    const fecha = (item) => {
        var parsedDate = item.split(" ")[0].split("-").reverse().join("/");
        return parsedDate
    }
    const getStatusLabel = (status) => {
        switch (status) {
            case 1:
                return "Sin integrar";
            case 2:
                return "Integrado";
            case 3:
                return "Borrador";
            default:
                return ""; // Si solo hay 3 casos, no debería existir un valor no manejado.
        }
    };
    return <>
        <TableContainer component={Paper} >
            <Table size='small'>
                <TableHead>
                    <TableRow>
                        <StyledTableCell align="center">Orden </StyledTableCell>
                        <StyledTableCell align="center">Usuario</StyledTableCell>
                        <StyledTableCell align="center">Fecha</StyledTableCell>
                        <StyledTableCell align="center">Notas</StyledTableCell>
                        <StyledTableCell align="center">Estado</StyledTableCell>
                        <StyledTableCell align="center">Total</StyledTableCell>
                        <StyledTableCell align="center">Editar</StyledTableCell>
                        <StyledTableCell align="center">Ver Detalle</StyledTableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {webOrder.length !== 0 ?
                        webOrder.map((item) => (
                            <TableRow key={item.webOrderId}>
                                <StyledTableCell align="center">{item.integrationId !== "XXX" && item.integrationId ? item.integrationId : item.webOrderId}</StyledTableCell>
                                <StyledTableCell align="center">{item.appUserId}</StyledTableCell>
                                <StyledTableCell align="center">{fecha(item.createdOn.slice(0, 10))}</StyledTableCell>
                                <StyledTableCell align="center">{item.notes}</StyledTableCell>
                                <StyledTableCell align="center">{
                                    getStatusLabel(item.status)
                                }</StyledTableCell>
                                <StyledTableCell align="center">{`$${item.total.toLocaleString()}`}</StyledTableCell>
                                <StyledTableCell align="center">
                                    <Button onClick={(event) => handleEditOrder(event, item)} disabled={item.status !== 3}>
                                        {item.status === 3 ? "Editar" : "No editable"}
                                    </Button>
                                </StyledTableCell>
                                <StyledTableCell align="center">
                                    <IconButton onClick={(event) => handleViewOrder(event, item)} size="large" ><InfoIcon /></IconButton>
                                </StyledTableCell>
                                {Object.keys(rowPopUp.item).length > 0 &&
                                    <PopUpOrder row={rowPopUp} setter={setRowPopUp} />
                                }
                            </TableRow>
                        ))
                        : <TableRow>
                            <TableCell />
                        </TableRow>}
                </TableBody>
            </Table>
        </TableContainer>
    </>
}